import './App.css';
import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import GuideService from './page/GuideService';
import MainMenu from './page/MainMenu';
import CheckPermissions from './page/checkPermissions/CheckPermissions';
import AccessDenied from './page/AccessDenied';
import Consent from './page/ConSent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HealthHistory from './page/point_of_care/HealthHistory';
import BloodTestResults from './page/point_of_care/BloodTestResults';
import SmartWatch from './page/point_of_care/SmartWatchResults';
import MedicalInformationNew from './page/medicalInformation/MedicalInformationNew';
import OffSiteLab from './page/offSiteLabResults/OffSiteLab';
import { AuthWrapper, PublicRoute } from './page/AuthWrapper';
import HealthResultsAnnual from './page/healthExamResultsAnnual/HealthResultsAnnual';
import CheckForwarding from './page/checkForwarding/CheckForwarding';
import AppointmentList from './page/appointmentList/AppointmentList';
import Consult from './page/consult/Consult';
import Refer from './page/referDoc/Refer';
import LoginCred from './page/LoginCred';
import LoginThaID from './page/LoginThaID';
import LoginPID from './page/LoginPID';
import AuthLayout from './page/AuthLayout'
import ViewXrayhistory from './page/xray/ViewXrayhistory';

function App() {

  useEffect(() => {

  }, [])

  useLayoutEffect(() => {
    document.body.style.backgroundColor = "#262673";
  }, [])

  return (
    <div>
      <ToastContainer toastStyle={{ backgroundColor: "white", color: "black" }} />
      <Router>
        <Routes>

          <Route element={<AuthLayout/>}>
            <Route path='/'
              element={
                <PublicRoute>
                  <GuideService />
                </PublicRoute>
              }
            />
            <Route path='/loginThaID' element={<LoginThaID />} />
            {/*<Route path='/loginCred' element={<LoginCred />} />*/}
            {/*<Route path='/loginPID' element={<LoginPID />} />*/}
            <Route path='/consent' element={<Consent />} />
          </Route>


          <Route
            element={
              <AuthWrapper>
                <Outlet />
              </AuthWrapper>
            }
          >
            <Route path='/mainMenu' element={<MainMenu />} />
            <Route path='/accessDenied' element={<AccessDenied />} />

            <Route path='/medicalInformationNew' element={<MedicalInformationNew />} />

            <Route path='/checkPermissions' element={<CheckPermissions />} />

            <Route path='/healthATM' element={<HealthHistory pageTitle="ผลจาก Sonka HealthATM" dataSource={"HealthATM"} />} />

            <Route path='/healthIoTs' element={<HealthHistory pageTitle="ผลจาก IoTs / HealthStation" dataSource={"IoTs"} />} />

            <Route path='/bloodResults' element={<BloodTestResults />} />

            <Route path='/smartWatch' element={<SmartWatch />} />

            <Route path='/offsiteLabResults' element={<OffSiteLab />} />

            <Route path='/healthResultsAnnual' element={<HealthResultsAnnual />} />

            <Route path='/checkForwarding' element={<CheckForwarding />} />

            <Route path='/appointmentList' element={<AppointmentList />} />

            <Route path='/consult' element={<Consult />} />

            <Route path='/refer' element={<Refer />} />

            <Route path='/xray' element={<ViewXrayhistory/>} />
          </Route>


        </Routes>
      </Router>
    </div>
  );
}

export default App;
